<template>
  <div
    :id="id"
    class="modal fade"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <modal-close-button @confirmed="closeModal" />
          <h4 class="modal-title">{{ $t('global.gradeoverview') }}</h4>
        </div>
        <div class="modal-body">
          <div class="row mb-3">
            <div class="col-12">
              <div class="font-weight-bold mb-1">Studienjahre:</div>
              <div
                v-for="block in bloecke"
                :key="block.index"
                class="custom-control custom-checkbox mt-1"
              >
                <input
                  :id="`nu-block-${block.index}`"
                  v-model="ausgewaehlteBloecke"
                  class="custom-control-input"
                  type="checkbox"
                  :value="block.index"
                />
                <label
                  class="custom-control-label pointer ml-2"
                  :for="`nu-block-${block.index}`"
                >
                  {{ block.bezeichnung }}
                  <span v-if="!block.hatNoten" class="text-muted">
                    (noch keine Noten)
                  </span>
                </label>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-12">
              <div class="custom-control custom-checkbox">
                <input
                  id="nu-ohne-note"
                  v-model="ohneNoteAnzeigen"
                  class="custom-control-input"
                  type="checkbox"
                />
                <label class="custom-control-label pointer ml-2" for="nu-ohne-note">
                  Module, Fächer und Testate ohne Note anzeigen
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="font-weight-bold mb-1">{{ $t('global.type') }}:</div>
              <div
                v-for="option in aktionen"
                :key="option.key"
                class="custom-control custom-radio mt-1"
              >
                <input
                  :id="`nu-aktion-${option.key}`"
                  v-model="aktion"
                  class="custom-control-input"
                  type="radio"
                  name="nu-aktion"
                  :value="option.key"
                />
                <label
                  class="custom-control-label pointer ml-2"
                  :for="`nu-aktion-${option.key}`"
                >
                  {{ option.label }}
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-success"
            :disabled="ausgewaehlteBloecke.length === 0"
            @click="ausgeben"
          >
            PDF ausgeben
          </button>
          <button type="button" class="btn btn-default" @click="closeModal">
            Schliessen
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ModalCloseButton from '@/components/global/ModalCloseButton'
  import { modal } from '@/mixins/Modal'

  // publish-Wert pro Aktion: null = anzeigen, false = zuweisen, true = zuweisen & publizieren
  const PUBLISH = { anzeigen: null, zuweisen: false, publizieren: true }

  export default {
    name: 'NotenuebersichtModulModal',
    mixins: [modal],
    components: {
      ModalCloseButton,
    },
    props: {
      id: {
        type: String,
        default: 'notenuebersicht-modul-modal',
      },
      // [{ index, bezeichnung, hatNoten }]
      bloecke: {
        type: Array,
        default: () => [],
      },
    },
    data() {
      return {
        ausgewaehlteBloecke: [],
        ohneNoteAnzeigen: false,
        aktion: 'anzeigen',
      }
    },
    computed: {
      aktionen() {
        return [
          { key: 'anzeigen', label: this.$t('global.show_c') },
          { key: 'zuweisen', label: this.$t('global.assign') },
          {
            key: 'publizieren',
            label: this.$t('global.assign') + ' & ' + this.$t('global.Publish'),
          },
        ]
      },
    },
    watch: {
      // Default: alle Studienjahre, in denen schon Noten vorhanden sind
      bloecke: {
        immediate: true,
        handler(val) {
          this.ausgewaehlteBloecke = (val || [])
            .filter((b) => b.hatNoten)
            .map((b) => b.index)
        },
      },
    },
    methods: {
      ausgeben() {
        this.$emit('ok', {
          bloecke: [...this.ausgewaehlteBloecke].sort((a, b) => a - b),
          ohneNoteAnzeigen: this.ohneNoteAnzeigen,
          publish: PUBLISH[this.aktion],
        })
        this.closeModal()
      },
    },
  }
</script>
